import { defineStore } from 'pinia'
import axios from '@/utils/axios'

const CACHE_TIME = 10 * 60 * 1000  // 10 minute

export const useLeadMetaStore = defineStore('leadMeta', {
  state: () => ({
    stages: [],
    sources: [],
    users: [],
    branches: [],
    lastFetch: 0,
    loading: false,
  }),

  persist: {
    paths: ['stages', 'sources', 'users', 'branches', 'lastFetch']
  },

  actions: {
    async loadAll(force = false) {
      const now = Date.now()
      const isFresh = this.lastFetch && (now - this.lastFetch) < CACHE_TIME
      const hasData = this.stages.length && this.sources.length &&
                this.users.length && this.branches.length

      if (!force && isFresh && hasData) return
      if (this.loading) return

      this.loading = true
      try {
        const results = await Promise.allSettled([
          axios.get('/lead-stages'),
          axios.get('/lead-sources'),
          axios.get('/users/all-users'),
          axios.get('/branches')
        ])

        const [stagesRes, sourcesRes, usersRes, branchesRes] = results

        if (stagesRes.status === 'fulfilled')   this.stages   = stagesRes.value.data.data
        if (sourcesRes.status === 'fulfilled')  this.sources  = sourcesRes.value.data.data
        if (usersRes.status === 'fulfilled')    this.users    = usersRes.value.data.data
        if (branchesRes.status === 'fulfilled') this.branches = branchesRes.value.data.data

        this.lastFetch = now
      } finally {
        this.loading = false
      }
    },

    refresh() {
      return this.loadAll(true)
    },

    async refreshStages() {
      try {
        const res = await axios.get('/lead-stages')
        this.stages = res.data.data
      } catch (e) {
        console.error('stages fetch error', e)
      }
    },

    async refreshSources() {
      try {
        const res = await axios.get('/lead-sources')
        this.sources = res.data.data
      } catch (e) {
        console.error('sources fetch error', e)
      }
    },

    async refreshUsers() {
      try {
        const res = await axios.get('/users/all-users')
        this.users = res.data.data
      } catch (e) {
        console.error('users fetch error', e)
      }
    },

    async refreshBranches() {
      try {
        const res = await axios.get('/branches')
        this.branches = res.data.data
      } catch (e) {
        console.error('branches fetch error', e)
      }
    },

    clearCache() {
      this.stages   = []
      this.sources  = []
      this.users    = []
      this.branches = []
      this.lastFetch = 0
      this.loading  = false
    }
  }
})